export const BIOBANK_STATUS = {
  CONSENT: 'CONSENT',
  REFUSAL: 'REFUSAL',
  NONE: 'NONE',
};
